import styled from 'styled-components'
import { CSS } from 'ui/helpers'

const Box = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0px;
  margin-top: auto;

  box-sizing: border-box;
  padding: 0px 12px 12px 12px;

  position: relative;

  &:before {
    content: '';
    position: absolute;
    bottom: 100%;
    z-index: 100;
    left: 0;
    width: 100%;
    min-height: 32px;
    background: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  }
`

const Inner = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;

  background-color: ${(props) => props.theme.uiKit.colors.global.grey.grey100};

  box-sizing: border-box;
  padding: 8px 16px;
  gap: 24px;
  border-radius: 8px;

  & > :last-child {
    margin-left: auto;
  }
`

const Panel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 8px;

  span {
    color: ${(props) => props.theme.uiKit.colors.global.grey.grey700};
    ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyL.regular)};
  }
`

export const s = { Box, Inner, Panel }
